import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-1"
};
const _hoisted_2 = {
  class: "flex items-center gap-3"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "flex items-center gap-3 ml-auto"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "empty:hidden max-w-full *:max-w-full overflow-y-auto"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "absolute top-3.5 right-3.5"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  return _openBlock(), _createElementBlock("div", _mergeProps({
    class: ["fixed inset-0 flex justify-center gap-2 bg-main-100/70 pt-12 pb-4 px-2 lg:px-10 z-50 text-main-100", {
      'contents': $props.contents
    }],
    onClick: _cache[9] || (_cache[9] = $event => this.computedBully ? undefined : this.computedOnclose?.())
  }, $options.currentSlot, {
    title: ""
  }), [$options.rawSlot ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    onDblclick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    class: "contents"
  }, [_renderSlot(_ctx.$slots, $options.activeSlot)], 32)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "relative animate-popup h-fit max-h-full max-w-full flex",
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
    onDblclick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["modal-container max-h-full max-w-full flex flex-col bg-main-5 shadow-material rounded-xl overflow-y-auto scroll-hidden [&>*:first-child]:pt-6 [&>*:last-child]:pb-6 *:px-6 *:py-3", [{
      'overflow-hidden': !this.overflow
    }]]),
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
    onDblclick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
    onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
  }, [$options.currentTitle || $options.currentText ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$options.currentHeaderIcon ? (_openBlock(), _createElementBlock("i", _mergeProps({
    key: 0,
    class: "cursor-pointer"
  }, $options.currentHeaderIcon), null, 16)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: "flex items-center gap-2 text-lg font-bold text-start",
    innerHTML: $options.currentTitle
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "header"), !this.hideCloseButton && this.computedOnclose ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    class: "icon-cross text-xl text-main-100 h-10 w-10 hover:rotate-90 transition-transform cursor-pointer active:scale-80",
    onClick: _cache[2] || (_cache[2] = (...args) => this.computedOnclose && this.computedOnclose(...args))
  })) : _createCommentVNode("", true)])]), $options.currentText ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "leading-relaxed",
    innerHTML: $options.currentText
  }, null, 8, _hoisted_5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [$options.activeSlot ? _renderSlot(_ctx.$slots, $options.activeSlot, {
    key: 0
  }) : _renderSlot(_ctx.$slots, "default", {
    key: 1
  }), $options.currentContent ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    innerHTML: $options.currentContent
  }, null, 8, _hoisted_7)) : _createCommentVNode("", true)]), $options.currentFooter?.length ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["flex flex-wrap items-center gap-3", $options.currentFooter?.length > 1 ? 'justify-between' : 'justify-end'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentFooter, button => {
    return _openBlock(), _createBlock(_component_Button, _mergeProps({
      key: button,
      ref_for: true
    }, button, {
      loading: button.loading,
      onclick: "",
      onClick: $event => this.HandleClick(button),
      class: {
        'mx-auto': button.center
      }
    }), null, 16, ["loading", "onClick", "class"]);
  }), 128))], 2)) : _createCommentVNode("", true)], 34), _createElementVNode("div", _hoisted_8, [!this.hideCloseButton && this.computedOnclose && !$options.currentTitle && !$options.currentText ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    class: "icon-cross text-xl text-main-100 h-10 w-10 hover:rotate-90 transition-transform cursor-pointer active:scale-80",
    onClick: _cache[6] || (_cache[6] = (...args) => this.computedOnclose && this.computedOnclose(...args))
  })) : _createCommentVNode("", true)])], 32))], 16);
}